import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController, Platform } from '@ionic/angular';
import { BASE_URL_PATH, SIDE_MENU, STONE_CREEK_ABOUT_URL, STONE_CREEK_MERCHANT_ID } from 'src/app/core/constants';
import { Platforms } from 'src/app/core/enums/util.enum';
import { UtilService } from 'src/app/core/services/util.service';
import { CartStore } from 'src/app/core/stores/cart.store';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent implements OnInit {
  public sideMenu = SIDE_MENU;

  constructor(
    private menuCtrl: MenuController,
    private utilService: UtilService,
    private router: Router,
    private cartStore: CartStore,
    private platform: Platform
  ) {
    this.cartStore.items$.subscribe(() => {
      this.cartStore.items.length > 0 ? this.toggleCartButton() : this.toggleCartButton(true);
    });
    this.cartStore.isLoyaltyProgramEnabled$
      .subscribe((result) => {
        return result ? this.toggleRewardsButton() : this.toggleRewardsButton(true);
      });
  }

  ngOnInit() {
    this.checkPlatform();
  }

  public closeSideMenu(): void {
    this.menuCtrl.close();
  }

  public handleNavigation(value: string): void {
    this.closeSideMenu();
    switch (value.toLowerCase()) {
      case 'home':
        this.utilService.navigateToHome();
        break;
      case 'cart':
        this.utilService.navigateToCheckout();
        break;
      case 'rewards':
        this.utilService.navigateToRewards();
        break;
      case 'order history':
        this.router.navigate([BASE_URL_PATH, STONE_CREEK_MERCHANT_ID, 'order-history']);
        break;
      case 'about stone creek':
        this.utilService.openInAppBrowser(STONE_CREEK_ABOUT_URL);
        break;
      case 'all locations':
        this.utilService.navigateToLocationPage();
        break;
      default:
        this.utilService.navigateToHome();
        break;
    }
  }

  private toggleCartButton(disabled: boolean = false): void {
    this.sideMenu = this.sideMenu.map((item) => {
      if (item.id === 2) {
        item.disabled = disabled;
      }
      return item;
    });
  }

  private toggleRewardsButton(hide: boolean = false): void {
    this.sideMenu = this.sideMenu.map((item) => {
      if (item.id === 3) {
        item.hide = hide;
      }
      return item;
    });
  }
  private checkPlatform(): void {
    if (!this.platform.is(Platforms.CORDOVA)) {
      this.sideMenu = this.sideMenu.map((item) => {
        if (item.id === 1) {
          item.hide = true;
        }
        return item;
      });
    }
  }
}
